module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/SzTAQO/tc-custom/9781488043079.jpg?1738382114228",
      "alt": "This image is the cover for the book Reunited in the Rockies, Rocky Mountain Heroes"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Reunited in the Rockies, Rocky Mountain Heroes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In this inspirational romance, a pregnant widow is reunited with her first love when they work together on a historic restoration in his small hometown.")]), _c('br'), _c('br'), _vm._v("For pregnant widow Kayla Bradshaw, restoring a historic Colorado hotel means a better life for her and her soon-to-arrive baby. But she needs construction help from Jude Stephens, the love she lost through a misunderstanding. Working with Kayla, the police officer finds himself forgiving her—and longing to rebuild her shattered confidence. But can they trust each other enough to forge a future together?"), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mindy Obenhaus\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Award-winning author Mindy Obenhaus lives on a ranch in Texas with her husband, two sassy pups and countless cattle. She’s passionate about touching readers with Biblical truths in an entertaining, and sometimes adventurous, manner. When she’s not writing, you’ll likely find her in the kitchen, spending time with her grandchildren or roaming the ranch in search of inspiration. She’d love to connect with you via her website, mindyobenhaus.com, or on Facebook.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0